import { combineReducers } from 'redux'
import { connectRouter } from 'connected-react-router'
import auth from './auth/reducers'
import user from './user/reducers'
import coordinator from './coordinator/reducers'
import role from './role/reducers'
import country from './country/reducers'
import county from './county/reducers'
import place from './place/reducers'
import season from './season/reducers'
import setting from './setting/reducers'
import language from './language/reducers'
import config from './config/reducers'
import registration from './registration/reducers'
import finalist from './finalist/reducers'
import interstate from './interstate/reducers'
import statistic from './statistic/reducers'
import sportCategory from './sport/category/reducers'
import sportCompetition from './sport/competition/reducers'
import sport from './sport/sport/reducers'
import organizer from './organizer/reducers'

export default history =>
  combineReducers({
    router: connectRouter(history),
    auth,
    user,
    coordinator,
    role,
    country,
    county,
    place,
    season,
    setting,
    language,
    config,
    sportCategory,
    sportCompetition,
    sport,
    registration,
    finalist,
    interstate,
    statistic,
    organizer,
  })
